export function viewContainer(width, styles){
  if(width >= 769)
    return styles.viewContainerMax;
  if(width >= 481)
    return styles.viewContainerMax1;
  if(width >= 350)
    return styles.viewContainerMax2;
  if(width<350)
    return styles.viewContainerMax3;
}